/*eslint-disable*/
const $ = require('jquery');
import moment from 'moment';
import { easepick } from '@easepick/core';
import { AmpPlugin } from '@easepick/amp-plugin';
import { RangePlugin } from '@easepick/range-plugin';
import { LockPlugin } from '@easepick/lock-plugin';
import { DateTime } from '@easepick/datetime';
import { Checkout } from './checkout.js';
require('./villas.js');
require('./homesearch.js');
require('./dynamic-map.js');

// Get the JSON string from the hidden input field
const availabilityDataEl = document.getElementById('availability-data');
const availabilityData = availabilityDataEl ? availabilityDataEl.value : null;


//Helper Functions
Date.prototype.addDays = function (days) {
  var dat = new Date(this.valueOf())
  dat.setDate(dat.getDate() + days);
  return dat;
}

function getVillaAvailabilityRanges(availabilityData = null) {

  if (availabilityData !== null) {
    // Parse it to an array of availability periods
    const availabilities = JSON.parse(availabilityData);

    // Function to parse dates in YYYY-MM-DD format correctly
    function parseDate(dateString) {
      // Split the date string into [YYYY, MM, DD]
      const parts = dateString.split("-");
      // Create a new date object with parsed values (Note: months are 0-indexed in JavaScript)
      return new Date(parts[0], parts[1] - 1, parts[2]);
    }

    // Extract available date ranges
    let availableRanges = availabilities
      .filter(period => period.state === "AVAILABLE")
      .map(period => {
        return [parseDate(period.startDate), parseDate(period.endDate)];
      });
      return availableRanges;
  }
  return [];
}

function getDates(startDate, stopDate) {
  var dateArray = new Array();
  var currentDate = startDate;

  // console.log(currentDate);
  // console.log(startDate);
  while (currentDate <= stopDate) {
    dateArray.push(currentDate)
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

function pretifyDate($date) {
  let months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun',
    'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  let b = $date.toString().split(/\W/);
  let startMonthNumber = months.indexOf(b[1].toLowerCase());
  let fixstartMonthNumber = ('0' + (parseInt(startMonthNumber + 1))).slice(-2);
  let startDate = b[3] + '-' + fixstartMonthNumber + '-' + b[2];
  return startDate
}

function searchFormHome() {
  const datepicker = $('#datepicker_home');
  if (datepicker.length > 0) {
    const currentUrl = window.location.protocol + '//' + window.location.hostname;

    const picker = new easepick.create({
      element: "#datepicker_home",
      css: [
        urls.theme + '/assets/css/easepick.css?' + Math.random()
        // "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css"
      ],
      zIndex: 10,
      grid: 2,
      calendars: 2,
      RangePlugin: {
        locale: {
          one: 'day',
          other: 'days',
        }
      },
      AmpPlugin: {
        darkMode: false
      },
      LockPlugin: {
        minDate: new Date(),
        // inseparable:   true,
        // filter: test,
        // filter(test, test) {
        //   return test;
        // return date.inArray(test, '[)');
        // }

        // minDate: new Date(),
        minDays: 2,
        inseparable: false,
      },
      plugins: [
        AmpPlugin,
        RangePlugin,
        LockPlugin
      ]
    });


    picker.on('select', (e) => {
      console.log('selected');
      let selectionIsValid = true;
      var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
      let i = 0;
      $('.datepicker__messages').empty();

      if (selectionIsValid === true) {
        //ajax call the booking form for the custom 
        //we need a table callendar with prices and side options
        // Update booking  Form
        let $nights = $('.nights').empty().html(dateArray.length);
        let $checkin = $('.checkin').empty().html(pretifyDate(dateArray[0]));
        let checkin = moment(pretifyDate(dateArray[0]), 'YYYY-MM-DD');
        let checkout = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
        let nights = dateArray.length;
        // checkout.add(1, 'day');
        // console.log(m);
        $('.checkout').empty().html(checkout.format('YYYY-MM-DD'));


        const checkinDate = checkin.format('YYYY-MM-DD')
        const checkoutDate = checkout.format('YYYY-MM-DD')

        // console.log(m.calendar());

        //update the hidden values
        // $('input[name=selectedates]').val(pretifyDate(dateArray[0])+' - '+m.format('YYYY-MM-DD'));
        $('input[name=checkin]').val(checkinDate);
        $('input[name=checkout]').val(checkoutDate);
        $('input[name=nights]').val(nights);

        //execute ajax getavailability
        // $('.allvillas__form').trigger('submit');
        // console.log('allvillas__form');

      }
    });


  }
}


// function datapickerCallendar() {
//   const datepicker = $('#datepicker');
//   if (datepicker.length > 0) {
//     let unvailableDates = datepicker.data('datesunavailable').split(',');

//     const bookedDates = unvailableDates.map(d => {
//       if (d instanceof Array) {
//         const start = new DateTime(d, 'YYYY-MM-DD');
//         // const end = new DateTime(d[1], 'YYYY-MM-DD');
//         return start;
//         // return [start, end];
//       }
//       return new DateTime(d, 'YYYY-MM-DD');
//     });


//     const picker = new easepick.create({
//       element: "#datepicker",
//       css: [
//         urls.theme + '/assets/css/easepick.css?' + Math.random()
//       ],
//       zIndex: 10,
//       grid: 2,
//       calendars: 2,
//       RangePlugin: {
//         locale: {
//           one: 'day',
//           other: 'days',
//         }
//       },
//       AmpPlugin: {
//         darkMode: false
//       },
//       LockPlugin: {
//         minDate: new Date(),
//         // inseparable:   true,
//         // filter: test,
//         // filter(test, test) {
//         //   return test;
//         // return date.inArray(test, '[)');
//         // }

//         // minDate: new Date(),
//         minDays: 2,
//         inseparable: false,
//         filter(date, picked) {
//           if (picked.length === 0) {
//             // console.log(date);
//             // console.log('=============================');
//             return date.inArray(bookedDates, '[)');
//           } else {
//             const incl = date.isBefore(picked[0]) ? '[)' : '(]';
//             return !picked[0].isSame(date, 'day') && date.inArray(bookedDates, incl);
//           }
//         },
//       },
//       plugins: [
//         AmpPlugin,
//         RangePlugin,
//         LockPlugin
//       ]
//     });


//     picker.on('view', (e) => {
//       const { view, date, target } = e.detail;
//       // do something
//     });
//     picker.on('render', (e) => {
//       // do something
//     });
//     picker.on('preselect', (e) => {
//       // do something
//     });
//     picker.on('select', (e) => {
//       let selectionIsValid = true;
//       var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
//       let i = 0;
//       $('.datepicker__messages').empty();
//       while (i < dateArray.length) {
//         if (new DateTime(dateArray[i]).inArray(bookedDates, '[)') === true) {
//           console.log('Unfortunately, we are booked on ' + new DateTime(dateArray[i]), 'YYYY-MM-DD');
//           $('.datepicker__messages').append('Unfortunately, we are booked on ' + pretifyDate(dateArray[i]) + '<br>');
//           picker.clear();
//           selectionIsValid = false;
//           console.log(('Did you select invalidate dates ? '));
//         }
//         i++;
//       }
//       if (selectionIsValid === true) {
//         //ajax call the booking form for the custom 
//         //we need a table callendar with prices and side options
//         // Update booking  Form
//         let $nights = $('.nights').empty().html(dateArray.length);
//         let $checkin = $('.checkin').empty().html(pretifyDate(dateArray[0]));
//         let m = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
//         // console.log(pretifyDate(dateArray[dateArray.length - 1]));
//         // console.log(dateArray.length);
//         m.add(1, 'day');
//         // console.log(m.format('YYYY-MM-DD'));
//         // console.log(m);
//         let $checkout = $('.checkout').empty().html(m.format('YYYY-MM-DD'));

//         let $cost = $('.booking-form__cost .cost').html(); // get the cost per night
//         // console.log($nights);
//         // console.log($checkout);
//         // console.log(m.calendar());

//         //update the hidden values
//         // $('input[name=selectedates]').val(pretifyDate(dateArray[0])+' - '+m.format('YYYY-MM-DD'));
//         $('input[name=checkin]').val(pretifyDate(dateArray[0]));
//         $('input[name=checkout]').val(m.format('YYYY-MM-DD'));
//         $('input[name=nights]').val(dateArray.length);

//       }
//     });
//     picker.on('clear', (e) => {
//       // do something
//     });
//   }
// }

// function datapickerInit(element) {
//   const datepicker = $(element);
//   if (datepicker.length > 0) {
//     datepicker.trigger("click");
//     let picker = new easepick.create({
//       element: element,
//       css: [
//         urls.theme + '/assets/css/easepick.css?' + Math.random()
//       ],
//       zIndex: 10,
//       grid: callendarGrid,
//       calendars: 2,
//       RangePlugin: {
//         locale: {
//           one: 'day',
//           other: 'days',
//         }
//       },
//       AmpPlugin: {
//         darkMode: false
//       },
//       LockPlugin: {
//         minDate: new Date(),
//         minDays: 2,
//         inseparable: false,
//       },
//       plugins: [
//         AmpPlugin,
//         RangePlugin,
//         LockPlugin
//       ]
//     });

//     picker.on('view', (e) => {
//       const { view, date, target } = e.detail;
//     });
//     picker.on('render', (e) => {
//     });
//     picker.on('preselect', (e) => {
//     });
//     picker.on('select', (e) => {
//       let selectionIsValid = true;
//       var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
//       let i = 0;
//       $('.datepicker__messages').empty();
//       if (selectionIsValid === true) {
//         let $nights = $('.nights').empty().html(dateArray.length);
//         let $checkin = $('.checkin').empty().html(pretifyDate(dateArray[0]));
//         let checkin = moment(pretifyDate(dateArray[0]), 'YYYY-MM-DD');
//         let checkout = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
//         let nights = dateArray.length;
//         // checkout.add(1, 'day');
//         $('.checkout').empty().html(checkout.format('YYYY-MM-DD'));
//         const checkinDate = checkin.format('YYYY-MM-DD')
//         const checkoutDate = checkout.format('YYYY-MM-DD')
//         $('input[name=checkin]').val(checkinDate);
//         $('input[name=checkout]').val(checkoutDate);
//         $('input[name=nights]').val(nights);
//         $('.datepicker-value').empty().html(checkinDate + ' ' + checkoutDate);
//       }
//     });
//     picker.on('clear', (e) => {
//     });
//   }
// }

function datapickerCallendarMasterHome() {
  const datepicker = $('#datepickerMaster');
  if (datepicker.length > 0) {
    datepicker.each(function () {
      $(this).trigger("click");

      let picker = new easepick.create({
        element: this,
        css: [
          urls.theme + '/assets/css/easepick-home.css?' + Math.random()
        ],
        zIndex: 10,
        grid: 2,
        calendars: 2,
        RangePlugin: {
          locale: {
            one: 'day',
            other: 'days',
          }
        },
        AmpPlugin: {
          darkMode: false
        },
        LockPlugin: {
          minDate: new Date(),
          minDays: 2,
          inseparable: false,
        },
        plugins: [
          AmpPlugin,
          RangePlugin,
          LockPlugin
        ]
      });

      picker.on('view', (e) => {
        const { view, date, target } = e.detail;
      });
      picker.on('render', (e) => {
      });
      picker.on('preselect', (e) => {
      });
      picker.on('select', (e) => {
        let selectionIsValid = true;
        var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
        let i = 0;
        $('.datepicker__messages').empty();
        $('.booking-form-response').empty();
        if (selectionIsValid === true) {
          let $nights = $('.nights').empty().html(dateArray.length);
          let $checkin = $('.checkin').empty().html(pretifyDate(dateArray[0]));
          let checkin = moment(pretifyDate(dateArray[0]), 'YYYY-MM-DD');
          let checkout = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
          let nights = dateArray.length;
          // checkout.add(1, 'day');
          $('.checkout').empty().html(checkout.format('YYYY-MM-DD'));
          const checkinDate = checkin.format('YYYY-MM-DD')
          const checkoutDate = checkout.format('YYYY-MM-DD')
          $('input[name=checkin]').val(checkinDate);
          $('input[name=checkout]').val(checkoutDate);
          $('input[name=nights]').val(nights);
          $('.datepicker-value').empty().html(checkin.format('DD MMM YYYY') + ' ⥊ ' + checkout.format('DD MMM YYYY'));
        }
      });
      picker.on('clear', (e) => {
      });
    });
  }
}

function datapickerCallendarMaster() {
  let callendarGrid = 2;
  if ($('body').hasClass('single-villas')) {
    callendarGrid = 2;
  }
  const datepicker = $('#datepickerMaster');

  // Get the default checkin and checkout values
  const defaultCheckin = $('input[name=checkin]').val();
  const defaultCheckout = $('input[name=checkout]').val();

  if (datepicker.length > 0) {
    datepicker.each(function () {
      $(this).trigger("click");

      let availableRanges = getVillaAvailabilityRanges(availabilityData);

      // Initialize the Easepick calendar
      let picker = new easepick.create({
        element: this,
        css: [
          urls.theme + '/assets/css/easepick.css?' + Math.random()
        ],
        zIndex: 10,
        grid: 2,
        calendars: 2,
        RangePlugin: {
          locale: {
            one: 'day',
            other: 'days',
          },
          startDate: defaultCheckin ? new Date(defaultCheckin) : null, // Default checkin date
          endDate: defaultCheckout ? new Date(defaultCheckout) : null // Default checkout date
        },
        AmpPlugin: {
          darkMode: false
        },
        LockPlugin: {
          minDate: new Date(), // Assuming you want to lock past dates
          inseparable: false,
          filter: function (date, picked) {
            if (availableRanges.length > 0) {
              // Check if the current date is within any available range
              for (let range of availableRanges) {
                if (date >= range[0] && date <= range[1]) {
                  return false;
                }
              }
              return true;
            }
          }
        },
        plugins: [
          AmpPlugin,
          RangePlugin,
          LockPlugin
        ]
      });

      console.log('picker', picker);

      picker.on('view', (e) => {
        const { view, date, target } = e.detail;
        // adjustPickerPosition(picker);

      });
      picker.on('render', (e) => {
        adjustPickerPosition(picker);
      });
      picker.on('preselect', (e) => {
        //adjustPickerPosition(picker);
      });
      picker.on('select', (e) => {
        let selectionIsValid = true;
        var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
        let i = 0;
        $('.datepicker__messages').empty();
        $('.booking-form-response').empty();
        if (selectionIsValid === true) {
          let checkin = moment(pretifyDate(dateArray[0]), 'YYYY-MM-DD');
          let checkout = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
          let nights = dateArray.length - 1;
          $('.checkout').empty().html(checkout.format('YYYY-MM-DD'));
          const checkinDate = checkin.format('YYYY-MM-DD');
          const checkoutDate = checkout.format('YYYY-MM-DD');
          $('input[name=checkin]').val(checkinDate);
          $('input[name=checkout]').val(checkoutDate);
          $('input[name=nights]').val(nights);
          $('.datepicker-value').empty().html(checkin.format('DD MMM YYYY') + ' ⥊ ' + checkout.format('DD MMM YYYY'));
        }
        adjustPickerPosition(picker, true);
        fixHideShowBookNowAvailabilityButton();

      });
      picker.on('clear', (e) => {
      });

      function adjustPickerPosition(picker, clear = false) {
        const pickerElement = picker.ui.container;
        const rect = pickerElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        pickerElement.classList.remove('position-above');

        if (rect.bottom > windowHeight) {
          pickerElement.classList.add('position-above');
        }
        if (clear) {
          pickerElement.classList.remove('position-above');
        }
      }
    });
  }
}



function datapickerCallendarMasterMobile() {
  let callendarGrid = 2;
  if ($('body').hasClass('single-villas')) {
    callendarGrid = 2;
  }
  const datepicker = $('#datepickerMaster2');
  if (datepicker.length > 0) {
    datepicker.each(function () {
      $(this).trigger("click");

      let availableRanges = getVillaAvailabilityRanges(availabilityData);

      let picker = new easepick.create({
        element: this,
        css: [
          urls.theme + '/assets/css/easepick.css?' + Math.random()
        ],
        zIndex: 10,
        grid: callendarGrid,
        calendars: 2,
        RangePlugin: {
          locale: {
            one: 'day',
            other: 'days',
          }
        },
        AmpPlugin: {
          darkMode: false
        },
        LockPlugin: {
          minDate: new Date(),
          minDays: 2,
          inseparable: false,
          filter: function (date, picked) {
            // Check if the current date is within any available range
            for (let range of availableRanges) {
              if (date >= range[0] && date <= range[1]) {
                return false;
              }
            }
            return true;
          }
        },
        plugins: [
          AmpPlugin,
          RangePlugin,
          LockPlugin
        ]
      });

      picker.on('view', (e) => {
        const { view, date, target } = e.detail;
      });
      picker.on('render', (e) => {
      });
      picker.on('preselect', (e) => {
      });
      picker.on('select', (e) => {
        let selectionIsValid = true;
        var dateArray = getDates(new Date(e.detail.start), new Date(e.detail.end));
        let i = 0;
        $('.datepicker__messages').empty();
        if (selectionIsValid === true) {
          let $nights = $('.nights').empty().html(dateArray.length);
          let $checkin = $('.checkin').empty().html(pretifyDate(dateArray[0]));
          let checkin = moment(pretifyDate(dateArray[0]), 'YYYY-MM-DD');
          let checkout = moment(pretifyDate(dateArray[dateArray.length - 1]), 'YYYY-MM-DD');
          let nights = dateArray.length;
          // checkout.add(1, 'day');
          $('.checkout').empty().html(checkout.format('YYYY-MM-DD'));
          const checkinDate = checkin.format('YYYY-MM-DD')
          const checkoutDate = checkout.format('YYYY-MM-DD')
          $('input[name=checkin]').val(checkinDate);
          $('input[name=checkout]').val(checkoutDate);
          $('input[name=nights]').val(nights);
          // $('.datepicker-value').empty().html(checkinDate + ' ' + checkoutDate);
          $('.datepicker-value').empty().html(checkin.format('DD MMM YYYY') + ' ⥊ ' + checkout.format('DD MMM YYYY'));
          fixHideShowBookNowAvailabilityButton();

        }
      });
      picker.on('clear', (e) => {
      });
    });
  }
}

function updateScrollTrigger() {
  setTimeout(function () {
    console.log('resize');
    window.dispatchEvent(new Event('resize'));
  }, 1300);
}

function ajaxSubmitForm() {
  const $form = $('.booking-form');
  const $formResponse = $('.booking-form-response');

  // var form = $('#contactForm1');
  $form.submit(function (e) {
    e.preventDefault();
    // $('.villas-loader').show();
    $('.villas-loader').addClass('loading');
    $('.single-villas__booking-form__loading').css('width', '50%');
    $('.single-villas__booking-form__loading').css('max-width', '50%');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function (data) {
        // $('.villas-loader').hide();
        $('.single-villas__booking-form__loading').css('width', '100%');
        $('.single-villas__booking-form__loading').css('max-width', '100%');
        $('.villas-loader').removeClass('loading');
        console.log('Submission was successful.');
        console.log(data);
        const parser = new DOMParser();
        let xmlDoc;
        let errorId = null;
        let errorMessage = null;
        let additionalMessage = null;

        try {
          // Attempt to parse the string as XML
          xmlDoc = parser.parseFromString(data, "text/xml");

          // Check if valid XML structure by checking if the <Error> element exists
          const errorElement = xmlDoc.getElementsByTagName('Error')[0];

          if (errorElement) {
            // It's valid XML, so extract <Id> and <Message>
            const idElement = xmlDoc.getElementsByTagName('Id')[0];
            errorId = idElement ? idElement.textContent : null;

            const messageElement = xmlDoc.getElementsByTagName('Message')[0];
            errorMessage = messageElement ? messageElement.textContent : null;

            // Check if there's any additional text outside of the XML
            const remainingTextMatch = data.match(/<\/small>(.*)$/);
            additionalMessage = remainingTextMatch ? remainingTextMatch[1].trim() : null;
          } else {
            // No <Error> element, treat data as plain string
            additionalMessage = data.trim();
          }
        } catch (e) {
          // If any error occurs while parsing, treat the whole data as a plain string
          additionalMessage = data.trim();
        }

        console.log(data);
        $('.single-villas__booking-form_submit').hide(); // hide the button /// but when user clickes guests or sth changes checking checkiout guests
        $('.single-villas__booking-form__rates__info').hide();  // hide the button /// but when user clickes guests or sth changes checking checkiout guests
        if (data.success === undefined) {
          $formResponse.empty().html(additionalMessage);
          console.log('ErrorID:', errorId);
          console.log('ErrorMessage:', errorMessage);

          updateScrollTrigger();
        } else {
          console.log("Success: " + success);
          // $formResponse.empty().html(data);
          //hide cthe chaeck availability button...

          updateScrollTrigger();

        }

        $('.single-villas__booking-form__loading').css('width', '0%');
        $('.single-villas__booking-form__loading').css('max-width', '0%');
        $('.single-villas__booking-form__loading').removeClass('active');
      },
      error: function (data) {
        console.log('An error occurred.');
        updateScrollTrigger();
        console.log(data);
        $formResponse.empty().html('An error Has occured , please try again.');
        $('.single-villas__booking-form__loading').css('width', '0');
        $('.single-villas__booking-form__loading').css('max-width', '0');
        $('.single-villas__booking-form__loading').removeClass('active');
      },
    });
    // For this example, let's simulate a delay with setTimeout
    setTimeout(function () {
      // Hide the loader when the processing is complete
      $('.single-villas__booking-form__loading').removeClass('active');
    }, 20);

  });
}

function fixHideShowBookNowAvailabilityButton() {
  $('.single-villas__booking-form_submit').show();
  $('.single-villas__booking-form__rates__info').show();
  $('.single-villas__booking-form--book__info').hide();
  $('.single-villas__booking-form__book').hide();
}

$(function () {

  const datepickerMaster = $('#datepickerMaster');
  if (datepickerMaster.length > 0) {
    if ($('body').hasClass('home')) {
      datapickerCallendarMasterHome();
    } else {
      datapickerCallendarMaster();
    }
  }
  const datepickerMaster2 = $('#datepickerMaster2');
  if (datepickerMaster2.length > 0) {
    datapickerCallendarMasterMobile();
  }
  const checkout = new Checkout;
  checkout.init();
  ajaxSubmitForm();
});





